import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableHead from '@mui/material/TableHead'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

import CircularProgress from '@mui/material/CircularProgress'
import styled from '@emotion/styled'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import Loader from '../Loader'
import { fetchDocumentRuleSets, showModal } from '../../redux/actions'
import { selectDocumentRuleSets } from '../../redux/selectors'
import { formatVerificationDocumentType } from '../../formatting'
import StyledLink from '../StyledLink'
import Header from '../Header'
import { reactPlugin } from '../../applicationInsights'
import Label from '../@Common/Form/Label/Label'

function Processing() {
  return (
    <div
      style={{
        position: 'relative',
        top: '50px',
        right: '0px',
        bottom: '0px',
        left: '0px',
        backgroundColor: 'rgba(255,255,255,.8)',
        overflow: 'hidden',
        zIndex: '100',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <CircularProgress />
      <p style={{ marginBottom: '0px', textAlign: 'center' }}>
        <Label>Fetching document rule sets...</Label>
      </p>
    </div>
  )
}

const compareNames = (a, b) => {
  if (a.name < b.name) return -1
  if (a.name > b.name) return 1
  return 0
}

const TableHeaderCell = styled(TableCell)({
  color: '#222',
  fontWeight: '600',
  padding: '4px 15px',
  height: '56px',
})

const TableBodyCell = styled(TableCell)({
  padding: '4px 15px',
})

export function DocumentRuleSetsPage() {
  const dispatch = useDispatch()
  const [loaded, setLoaded] = useState(false)

  const documentRuleSets = useSelector(selectDocumentRuleSets)

  const getDocumentRuleSets = () => {
    setLoaded(false)
    return dispatch(fetchDocumentRuleSets()).then(() => setLoaded(true))
  }
  const viewRules = (ruleSet) => dispatch(showModal('RULE_SET_INFO', { ruleSet }))

  useEffect(() => {
    getDocumentRuleSets()
  }, [])
  if (!loaded) return <Loader />
  return (
    <div>
      <Header title="Document Rules" />
      {/* eslint-disable-next-line no-nested-ternary */}
      {documentRuleSets ? (
        documentRuleSets.length > 0 ? (
          <Table>
            <TableHead sx={{ backgroundColor: '#f1f1f1' }}>
              <TableRow>
                <TableHeaderCell sx={{ minWidth: '140px' }}>
                  Display Name
                </TableHeaderCell>
                <TableHeaderCell>
                  Affiliations
                </TableHeaderCell>
                <TableHeaderCell sx={{ minWidth: '140px' }}>
                  Document Types
                </TableHeaderCell>
                <TableHeaderCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {documentRuleSets
                && documentRuleSets.length > 0
                && documentRuleSets.sort(compareNames).map((u, i) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <TableRow key={i}>
                    <TableBodyCell>{u.name}</TableBodyCell>
                    <TableBodyCell>
                      {[...new Set(u.verificationRuleSets.map((x) => x.occupationId))].join(', ')}
                    </TableBodyCell>
                    <TableBodyCell>
                      {[...new Set(u.verificationRuleSets.map((x) => formatVerificationDocumentType(x.verificationDocumentType)))].join(', ')}
                    </TableBodyCell>
                    <TableBodyCell sx={{ textAlign: 'right', paddingRight: '24px' }}>
                      <StyledLink contents="View Rules" onClick={() => viewRules(u)} clickHandlerOnly styles={{ whiteSpace: 'nowrap' }} />
                    </TableBodyCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        ) : (
          <p>No document rule sets configured</p>
        )
      ) : (
        <Processing />
      )}
    </div>
  )
}

export default withAITracking(reactPlugin, DocumentRuleSetsPage)
